import React from 'react';
import { FilePresentOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';

import { gray3, gray4, lighterGray } from 'utils/color-styles';

import { PDFViewer } from '../PDFViewer/PDFViewer';

export const DocumentViewer = ({ receiptUrl, width }: { receiptUrl: string; width: number }) => (
  <div
    style={{
      textAlign: 'center',
      border: `1px dashed ${gray4}`,
      borderRadius: 4,
      background: lighterGray,
    }}
  >
    <div style={{ padding: 20 }}>
      {receiptUrl.endsWith('.pdf') ? (
        <PDFViewer url={receiptUrl} width={width} />
      ) : (
        <img style={{ width: '100%' }} src={receiptUrl} alt="Preview" />
      )}
    </div>
    <div
      style={{
        // @TODO-DP: add new colours to the theme
        background: '#EBEBEB',
        display: 'flex',
        alignItems: 'center',
        padding: 8,
      }}
    >
      <FilePresentOutlined htmlColor={gray3} style={{ marginLeft: 8, marginRight: 8 }} />
      <Typography style={{ overflow: 'hidden' }}>{receiptUrl.split('/').pop()}</Typography>
    </div>
  </div>
);
